// Copyright (c) 2018 Comsearch, Inc., All rights reserved

export const CALLSIGN_CASCADE_FORM = 'CALLSIGN_CASCADE_FORM'
